import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import ChargePointSelectors from 'Stores/ChargePoint/Selectors'
import ChargePointActions from 'Stores/ChargePoint/Actions'
import Styles from './AlertList.module.css'
import RequestState from 'Enums/RequestState'
import { AlertItem, AlertItemSkeleton } from 'Components'
import { Virtuoso } from 'react-virtuoso'
import { EmptySpecs } from 'Components/IFEmptyStates/IFEmptyStates'
import { useTranslation } from 'react-i18next'
import { useOverlayScrollbars } from 'overlayscrollbars-react'
import 'overlayscrollbars/overlayscrollbars.css'
const AlertList = ({
  combinedAlerts,
  fetchChargePointSubscribedAlertsRequestState,
  chargePoint,
  isEdit,
  onIconClick,
  onToggle,
  fetchChargePointAlertsRequestState,
}) => {
  const { t } = useTranslation()

  const isChargePointIncluded = (alertItem) => {
    return !alertItem.exclude?.includes(chargePoint.huid)
  }
  const rootRef = useRef(null)
  const options = {
    scrollbars: {
      visibility: 'auto',
      autoHide: 'move',
      autoHideDelay: 1000,
    },
  }
  const [scroller, setScroller] = useState(null)
  const [initialize, osInstance] = useOverlayScrollbars({
    options,
    defer: true,
  })
  useEffect(() => {
    const { current: root } = rootRef
    if (scroller && root) {
      initialize({
        target: root,
        elements: {
          viewport: scroller,
        },
      })
    }
    return () => osInstance()?.destroy()
  }, [scroller, initialize, osInstance])

  return (
    <div className={Styles.ListContainer}>
      {fetchChargePointSubscribedAlertsRequestState === RequestState.LOADING ||
      fetchChargePointAlertsRequestState === RequestState.LOADING ? (
        <div>
          {[...Array(5)].map((e, index) => {
            return (
              <div className={Styles.ItemContainer}>
                <div className={Styles.Item}>
                  <AlertItemSkeleton key={index} />
                </div>
              </div>
            )
          })}
        </div>
      ) : combinedAlerts.length === 0 ? (
        <EmptySpecs title={t('AlertModal.NoAlertsAvailable')} />
      ) : (
        <div
          ref={rootRef}
          data-overlayscrollbars=""
          style={{
            width: '100%',
            height: '100%',
          }}
        >
          <Virtuoso
            data={combinedAlerts}
            increaseViewportBy={480}
            scrollerRef={setScroller}
            itemContent={(index, alert) => {
              return (
                <div className={Styles.ItemContainer}>
                  <div className={Styles.Item}>
                    <AlertItem
                      key={index}
                      name={alert.name}
                      trackedStatus={alert.trackedStatus}
                      duration={alert.duration}
                      percentageAffected={alert.percentageAffected}
                      isIncluded={isChargePointIncluded(alert)}
                      isGlobal={alert.isGlobal}
                      isEdit={isEdit}
                      onIconClick={(value) => onIconClick(value, alert._id)}
                      onToggle={(value) => {
                        onToggle(value, alert._id)
                      }}
                      disableHover={false}
                    />
                  </div>
                </div>
              )
            }}
          />
        </div>
      )}
    </div>
  )
}

function mapDispatchToProps(dispatch) {
  return {
    updateChargePointConfig: (chargePointId, key, value, onSucess, onFail) =>
      dispatch(
        ChargePointActions.updateChargePointConfig(
          chargePointId,
          key,
          value,
          onSucess,
          onFail,
        ),
      ),
  }
}

const mapStateToProps = (state) => ({
  fetchChargePointSubscribedAlertsRequestState:
    ChargePointSelectors.getFetchChargePointSubscribedAlertsRequestState(state),
  chargePoint: ChargePointSelectors.getSelectedChargePoint(state),
  fetchChargePointAlertsRequestState:
    ChargePointSelectors.getFetchChargePointAlertsRequestState(state),
})

AlertList.propTypes = {
  combinedAlerts: PropTypes.arrayOf(PropTypes.object),
  fetchChargePointSubscribedAlertsRequestState: PropTypes.number,
  chargePoint: PropTypes.object,
  isEdit: PropTypes.bool,
  onIconClick: PropTypes.func,
  onToggle: PropTypes.func,
  fetchChargePointAlertsRequestState: PropTypes.number,
}

export default connect(mapStateToProps, mapDispatchToProps)(AlertList)
